import live from './live.js';
import other from './other';
import AI from './AI.js';
import material from './material';

export default [...live, ...other, ...AI, ...material];
